import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, shareReplay, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private isExpandedSubjectTime = new BehaviorSubject<boolean>(false);
  isExpandedTime$ = this.isExpandedSubjectTime.asObservable();

  //crimcheck sidebar Expension//
  private isExpandedSubject = new BehaviorSubject<boolean>(false);
  isExpanded$ = this.isExpandedSubject.asObservable();

  toggleExpandedState(isExpanded: boolean) {
    this.isExpandedSubject.next(isExpanded);
  }
  // ====//
  private valueChangedSource = new Subject<any>();
  valueChanged$ = this.valueChangedSource.asObservable();
  triggerValueChange(value: any) {
    this.valueChangedSource.next(value);
  }

  toggleExpandedState1(isExpandedTime: boolean) {
    this.isExpandedSubjectTime.next(isExpandedTime);
  }

  removeSpecialCharacterFileName(file: File): File {
    if (file) {
      const fileName = file.name.replace(/[#$&+]/g, ''); // Trim special characters
      return new File([file], fileName, { type: file.type });
    } else {
      return new File([file], '', { type: '' });
    }
  }

  formatBytes(bytes: number, decimals = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));

    return `${size} ${sizes[i]}`;
  }

  async isFileSignatureValid(file: File): Promise<boolean> {
    const extension = file.name.substring(file.name.lastIndexOf('.'));

    const reader = new FileReader();
    const headerBytes = new Uint8Array(8);

    reader.readAsArrayBuffer(file.slice(0, headerBytes.length));

    return new Promise<boolean>((resolve, reject) => {
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const view = new DataView(arrayBuffer);

        // TODO: Fix Excel upload, that is downloaded from ENWAGE APP
        switch (extension) {
          case '.png':
          case '.doc':
          case '.docx':
          case '.xls':
          case '.xlsx':
            headerBytes.set(new Uint8Array(arrayBuffer.slice(0, 8)));
            break;

          case '.pdf':
            headerBytes.set(new Uint8Array(arrayBuffer.slice(0, 4)));
            break;

          case '.jpg':
          case '.jpeg':
            headerBytes.set(new Uint8Array(arrayBuffer.slice(0, 2)));
            break;

          case '.mp4':
            headerBytes.set(new Uint8Array(arrayBuffer.slice(0, 8)));
            break;

          default:
            return resolve(false);
        }

        if (extension === '.mp4') {
          const mp4TypeOneSig = [
            0x00, 0x00, 0x00, 0x20, 0x66, 0x74, 0x79, 0x70,
          ];
          const mp4TypeTwoSig = [
            0x00, 0x00, 0x00, 0x18, 0x66, 0x74, 0x79, 0x70,
          ];

          let mp4SigOneMatch = true;
          let mp4SigTwoMatch = true;

          for (let i = 0; i < 8; i++) {
            if (headerBytes[i] !== mp4TypeOneSig[i]) {
              mp4SigOneMatch = false;
            }

            if (headerBytes[i] !== mp4TypeTwoSig[i]) {
              mp4SigTwoMatch = false;
            }
          }

          return resolve(mp4SigOneMatch || mp4SigTwoMatch);
        }

        const docMagicNumbers: { [key: string]: number[] } = {
          '.doc': [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1],
          '.docx': [0x50, 0x4b, 0x03, 0x04, 0x14, 0x00, 0x06, 0x00],
          '.xls': [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1],
          '.xlsx': [0x50, 0x4b, 0x03, 0x04, 0x14, 0x00, 0x06, 0x00],
          '.png': [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a],
          '.pdf': [0x25, 0x50, 0x44, 0x46],
          '.jpg': [0xff, 0xd8],
          '.jpeg': [0xff, 0xd8],
        };

        if (docMagicNumbers[extension]) {
          for (let i = 0; i < docMagicNumbers[extension].length; i++) {
            if (headerBytes[i] !== docMagicNumbers[extension][i]) {
              return resolve(false);
            }
          }
          return resolve(true);
        } else {
          return resolve(false);
        }
      };

      reader.onerror = () => {
        reject('Error reading file');
      };
    });
  }
}
